import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DrawerModule } from 'primeng/drawer';
import { DatePickerModule } from 'primeng/datepicker';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ButtonModule } from 'primeng/button';
import { ActiveSlicers, DashboardStateService, InvoiceTypeFilter } from '../../../services/dashboard-state.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-slicers-panel',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DrawerModule,
    DatePickerModule,
    MultiSelectModule,
    SelectButtonModule,
    ButtonModule,
  ],
  templateUrl: './slicers-panel.component.html',
})
export class SlicersPanelComponent implements OnInit, OnDestroy {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  private readonly dashboardState = inject(DashboardStateService);
  private readonly sub = new Subscription();

  localDateRange: Date[] | null = null;
  localStatus: string[] = [];
  localInvoiceType: InvoiceTypeFilter = 'all';

  readonly statusOptions = ['Paid', 'Authorised', 'Overdue', 'Draft'];
  readonly typeOptions = [
    { label: 'All', value: 'all' },
    { label: 'Sales Only', value: 'sales' },
    { label: 'Purchases Only', value: 'purchases' },
  ];

  ngOnInit(): void {
    this.sub.add(
      this.dashboardState.activeSlicers$.subscribe(s => {
        this.localStatus = [...s.status];
        this.localInvoiceType = s.invoiceType;
      })
    );
    this.sub.add(
      this.dashboardState.globalDateRange$.subscribe(range => {
        this.localDateRange = range ? [range.startDate, range.endDate] : null;
      })
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  applyFilters(): void {
    this.dashboardState.setSlicers({
      status: this.localStatus,
      invoiceType: this.localInvoiceType,
    });
    if (this.localDateRange?.[0] && this.localDateRange[1]) {
      this.dashboardState.setGlobalDateRange(this.localDateRange[0], this.localDateRange[1]);
    } else if (!this.localDateRange || this.localDateRange.length === 0) {
      this.dashboardState.clearGlobalDateRange();
    }
    this.visibleChange.emit(false);
  }

  resetFilters(): void {
    this.localStatus = [];
    this.localInvoiceType = 'all';
    this.localDateRange = null;
    this.dashboardState.resetGlobalFilters();
    this.visibleChange.emit(false);
  }
}
